import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Injector, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { PaginationFilter } from '../../interfaces';
import { BasePaginatorComponent } from '../base-paginator/base-paginator-component';
import { PaginatorComponent } from '../paginator/paginator.component';
import { SpinnerComponent } from '../spinner/spinner.component';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { EmptyStateComponent } from '../empty-state/empty-state.component';

@Component({
  selector: 'app-table-pagination-layout',
  standalone: true,
  imports: [CommonModule, PaginatorComponent, SpinnerComponent, EmptyStateComponent],
  templateUrl: './table-pagination-layout.component.html',
  styleUrls: ['./table-pagination-layout.component.scss'],
})
export class TablePaginationLayoutComponent extends BasePaginatorComponent implements OnChanges {
  showLoading: boolean;
  @Input() length: number;
  @Input() override isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  @Input() showPaginator: boolean = true;
  @Output() paginationFilter: EventEmitter<PaginationFilter> = new EventEmitter<PaginationFilter>();
  constructor(injector: Injector) {
    super([], injector);
  }
  ngOnChanges(changes: SimpleChanges): void {}

  ngOnInit(): void {
    this.showLoadingSpinner();
  }

  // publics
  override getPaginationFilter(filter: PaginationFilter) {
    this.paginationFilter.emit(filter);
  }

  private showLoadingSpinner(): void {
    this.isLoading.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.showLoading = res;
    });
  }
}
